__turbopack_context__.v({
  "container": "about-module__WcShDW__container",
  "fadeInItems": "about-module__WcShDW__fadeInItems",
  "spacing--lg": "about-module__WcShDW__spacing--lg",
  "spacing--md": "about-module__WcShDW__spacing--md",
  "spacing--sm": "about-module__WcShDW__spacing--sm",
  "spacing--xl": "about-module__WcShDW__spacing--xl",
  "spacing--xs": "about-module__WcShDW__spacing--xs",
  "spacing--xxl": "about-module__WcShDW__spacing--xxl",
  "spacing--xxs": "about-module__WcShDW__spacing--xxs",
  "spacing--xxxl": "about-module__WcShDW__spacing--xxxl",
  "spacing--xxxs": "about-module__WcShDW__spacing--xxxs",
});
